import { ALL_SITES } from '@tempus/trials-types';

export const allSitesOption = { value: ALL_SITES, label: ALL_SITES };

export enum TCLBoronComponentStatus {
  DEFAULT = 'default',
  ERROR = 'error',
  WARNING = 'warning',
}
